<div class="flex flex-col h-screen bg-[#f8fafc]">
    <app-header (toggleSidebar)="sidebar.toggleSidebar()"></app-header>

    <div class="flex flex-1 relative min-h-0">
        <app-sidebar #sidebar></app-sidebar>

        <main class="flex-1 overflow-y-auto sm:px-[10vw] scrollable-main">
            <div class="max-w-2xl mx-auto py-6 px-4">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>
</div>
